import * as React from "react";
import {
  Callout,
  Spinner,
  SpinnerSize,
  Label,
  ChoiceGroup,
  IChoiceGroupOption,
  Pivot,
  PivotItem,
  SearchBox,
  Button,
  IPivotItemProps,
  ISearchBoxStyles
} from "office-ui-fabric-react";
import axios from "axios";
import {
  checkAccessTokenIsExpired,
  refreshAccessToken
} from "../service/RefreshToken";
import ReactDOM = require("react-dom");
import { APIUrls } from "../environments/ConfigDetails";
import SignIn from "./SignIn";

export interface MatterSearchProps {
  onMatterChanged;
  selectedMatter: any;
  onRecentMatterChanged;
  isItemChanged: boolean;
}
export interface MatterSearchState {
  matterSearchText: string;
  isCalloutVisible: boolean;
  isMatterSearching: boolean;
  mattersList: any[];
  recentMatters: IChoiceGroupOption[];
  isErrorInSearch: boolean;
  selectedPivotKey: string;
}

let matters = [];
class MatterSearch extends React.Component<
  MatterSearchProps,
  MatterSearchState
> {
  private menuButtonElement: HTMLElement | null;
  constructor(props, {}) {
    super(props, {});

    this.state = {
      matterSearchText: "",
      isCalloutVisible: false,
      isMatterSearching: false,
      mattersList: [],
      recentMatters: [],
      isErrorInSearch: false,
      selectedPivotKey: "RecentlyUsed"
    };
  }
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    if (nextProps.isItemChanged) {
      let matters = this.getRecentMatters();
      this.setState({
        recentMatters: matters,
        matterSearchText: "",
        selectedPivotKey: matters.length > 0 ? "RecentlyUsed" : "Search"
      });
    } else {
      if (nextProps.selectedMatter !== null) {
        let matters = this.getRecentMatters();
        if (
          matters.filter(x => x.key === nextProps.selectedMatter.Id).length > 0
        ) {
          //if matter is selected already then select the matter
          matters.find(
            x => x.key === nextProps.selectedMatter.Id
          ).checked = true;
        }
        this.setState({
          recentMatters: matters,
          selectedPivotKey: matters.length > 0 ? "RecentlyUsed" : "Search"
        });
      } else {
        let matters = this.getRecentMatters();
        this.setState({
          recentMatters: matters,
          selectedPivotKey: matters.length > 0 ? "RecentlyUsed" : "Search"
        });
      }
    }
  }
  render() {
    let { recentMatters, selectedPivotKey } = this.state;
    if (recentMatters.length === 0) {
      recentMatters = this.getRecentMatters();
      selectedPivotKey = recentMatters.length > 0 ? "RecentlyUsed" : "Search";
    }
    const searchboxStyles = (): ISearchBoxStyles => {
      return {
        root: {
          fontFamily: "Lato",
          fontWeight: "normal",
          color: "black",
          fontSize: 14
        }
      };
    };
    // let selectedKey = recentMatters.length === 0 ? `1` : `1`;
    return (
      <Pivot
        onLinkClick={this.onPivotLinkClick}
        defaultSelectedKey={selectedPivotKey}
      >
        <PivotItem
          itemKey={`RecentlyUsed`}
          onRenderItemLink={this.onRenderPivotItemLink}
          headerText="Recently Used"
          headerButtonProps={{
            "data-order": 1,
            "data-title": "Recently Used Title"
          }}
        >
          <div className="ms-Grid" dir="ltr" style={{ marginTop: "10px" }}>
            {recentMatters.length === 0 && (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <Label
                    style={{
                      fontFamily: "Lato",
                      fontWeight: "normal",
                      color: "#939799",
                      fontSize: 14
                    }}
                  >
                    You don't have any recently used matters.
                  </Label>
                </div>
              </div>
            )}
            <ChoiceGroup
              style={{ marginTop: 15 }}
              className="recentMatters"
              key="recentmatters"
              options={recentMatters}
              onChange={this.onRecentMatterChanged}
            />
          </div>
        </PivotItem>
        <PivotItem
          itemKey={`Search`}
          headerText="Search for Matter"
          onRenderItemLink={this.onRenderPivotItemLink}
        >
          <div className="ms-Grid" dir="ltr" style={{ marginTop: 15 }}>
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
                ref={menuButton => (this.menuButtonElement = menuButton)}
              >
                <SearchBox
                  placeholder="Type the matter you’re looking for…"
                  onChange={this.searchChanged}
                  onSearch={this.searchMatters}
                  value={this.state.matterSearchText}
                  styles={searchboxStyles}
                  autoComplete={"off"}
                />
                <Callout
                  style={{ width: "301px", maxHeight: 200 }}
                  className="ms-CalloutExample-callout"
                  ariaLabelledBy={"callout-label-1"}
                  ariaDescribedBy={"callout-description-1"}
                  role={"alertdialog"}
                  gapSpace={0}
                  target={this.menuButtonElement}
                  onDismiss={this.onCalloutDismiss}
                  setInitialFocus={true}
                  hidden={!this.state.isCalloutVisible}
                  isBeakVisible={false}
                >
                  <div className="ms-CalloutExample-inner">
                    <div
                      className="ms-CalloutExample-content"
                      style={{ paddingLeft: 10 }}
                    >
                      {this.state.isMatterSearching && (
                        <Spinner
                          size={SpinnerSize.large}
                          label={"Loading..."}
                          style={{ marginTop: "30px", marginBottom: "30px" }}
                        />
                      )}
                      {this.state.mattersList.length === 0 &&
                        !this.state.isMatterSearching && (
                          <Label
                            style={{
                              fontFamily: "Lato",
                              fontWeight: "normal",
                              color: "#939799",
                              fontSize: 14,
                              fontStyle: "italic"
                            }}
                          >
                            No matching results…
                          </Label>
                        )}
                      {this.state.isErrorInSearch &&
                        !this.state.isMatterSearching && (
                          <Label
                            style={{
                              fontFamily: "Lato",
                              fontWeight: "normal",
                              color: "#939799",
                              fontSize: 14,
                              fontStyle: "italic"
                            }}
                          >
                            Something went wrong…
                          </Label>
                        )}
                      {this.state.mattersList.length > 0 &&
                        !this.state.isMatterSearching && (
                          <div>
                            {this.state.mattersList.map((item, index) => (
                              <div key={index}>
                                <Button
                                  type={`button`}
                                  id={item.key}
                                  style={{
                                    maxWidth: "100%",
                                    backgroundColor: "white",
                                    fontFamily: "Lato",
                                    fontWeight: "normal",
                                    color: "black",
                                    fontSize: 14
                                  }}
                                  onClick={this.onhandleClick(item)}
                                >
                                  <div className="ms-Button-flexContainer flexContainer-81">
                                    {" "}
                                    <span className="css-534">
                                      <span className="ms-ComboBox-optionText css-532">
                                        {item.text}
                                      </span>
                                    </span>
                                  </div>
                                </Button>
                                <br />
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  </div>
                </Callout>
              </div>
            </div>
          </div>
        </PivotItem>
      </Pivot>
    );
  }

  //update state when search text is changed
  searchChanged = (value): void => {
    const actualValue = value && value.target && value.target.value !== undefined 
      ? value.target.value 
      : value;
    this.setState({
      matterSearchText: actualValue,
      isCalloutVisible: false
    });
  };
  //key down function for matter search text box
  textBoxKeyDown = event => {
    if (this.state.matterSearchText) {
      if (event.keyCode == 13 && event.shiftKey == false) {
        this.searchMatters();
      }
    }
  };
  //search matters
  searchMatters = () => {
    let settings = Office.context.roamingSettings;
    let workspaceUrlPrefix =
    typeof settings.get("WorkspaceURLPrefix") !== "undefined"
      ? settings.get("WorkspaceURLPrefix")
    : "eng-outlook"; 
  let workspaceUrltld =
    typeof settings.get("WorkspaceURLtld") !== "undefined"
      ? settings.get("WorkspaceURLtld")
    : "com"; 
    let url = APIUrls.urlForSearchMatters(workspaceUrlPrefix, workspaceUrltld);
    try {
      let accessTokenObj = settings.get("accessTokenObj");
      let isExpired = checkAccessTokenIsExpired();
      if (isExpired) {
        //refresh the token
        let newToken = refreshAccessToken();
        accessTokenObj = newToken;
        if (newToken === null) {
          ReactDOM.render(<SignIn />, document.getElementById("container"));
        } else {
          //continue process
        }
      }
      if (
        typeof accessTokenObj !== "undefined" &&
        accessTokenObj !== null &&
        this.state.matterSearchText
      ) {
        this.setState({
          isCalloutVisible: true,
          mattersList: [],
          isMatterSearching: true
        });
        let searchParam = {
          SearchKey: this.state.matterSearchText
        };
        url = url + searchParam.SearchKey;
        this.searchMattersAPIRequest(url, accessTokenObj.access_token, false);
      }
    } catch (error) {
      console.error(error)
    }
  };
  //callout dismiss function
  onCalloutDismiss = (): void => {
    this.setState({
      isCalloutVisible: false
    });
  };
  //click on item in search results
  onhandleClick = item => {
    return () => this.onMatterChanged(item);
  };
  //update state
  onMatterChanged = option => {
    this.setState({ matterSearchText: option.text, isCalloutVisible: false });
    this.props.onMatterChanged(option);
  };
  //make search API call
  searchMattersAPIRequest = (url, accessToken, isNextUrl): any => {
    let nextUrl = "";
    matters = isNextUrl ? matters : [];
    //let responseObj = null;
    try {
      axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          nextUrl = response.data.next;
          let resultList = response.data.results;

          for (let i = 0; i < resultList.length; i++) {
            matters.push({
              key: resultList[i].id,
              text: resultList[i].name,
              url: resultList[i].url
            });
          }
          if (nextUrl) {
            //next URL is available
            this.searchMattersAPIRequest(nextUrl, accessToken, true);
          } else {
            this.setState({
              mattersList: matters,
              isMatterSearching: false,
              isErrorInSearch: false
            });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            //unauthorized error - redirect to signin page
            ReactDOM.render(<SignIn />, document.getElementById("container"));
          } else {
            console.error(err);
            this.setState({
              mattersList: matters,
              isMatterSearching: false,
              isErrorInSearch: true
            });
          }
        });
    } catch (error) {
      console.error(error);
      this.setState({
        mattersList: matters,
        isMatterSearching: false,
        isErrorInSearch: true
      });
    }
  };
  //get recent matters
  getRecentMatters = (): any[] => {
    let matters = [];
    let settings = Office.context.roamingSettings;
    if (typeof settings.get("SelectedMattersList") !== "undefined") {
      let latestUsedMatters: any[];
      latestUsedMatters = settings.get("SelectedMattersList");
      if (latestUsedMatters.length <= 5) {
        //latest used matters length is less than or equal to 5
        for (let i = 0; i < latestUsedMatters.length; i++) {
          if (
            matters.filter(x => x.key === latestUsedMatters[i].MatterId)
              .length === 0
          ) {
            matters.push({
              key: latestUsedMatters[i].MatterId,
              text: latestUsedMatters[i].Name,
              checked: false
            });
          }
        }
      } else {
        //latest used matters length is more than 5 then add latest used 5 matters
        latestUsedMatters.forEach(matter => {
          if (
            matters.length < 5 &&
            matters.filter(x => x.key === matter.MatterId).length === 0
          ) {
            matters.push({
              key: matter.MatterId,
              text: matter.Name,
              checked: false
            });
          }
        });
      }
    }
    return matters;
  };
  onRecentMatterChanged = (_, option: IChoiceGroupOption) => {
    let { recentMatters } = this.state;
    if (recentMatters.filter(x => x.key === option.key).length > 0) {
      recentMatters.find(x => x.key === option.key).checked = true;
    }
    this.setState({ matterSearchText: "", recentMatters: recentMatters });
    this.props.onRecentMatterChanged(option);
  };
  onRenderPivotItemLink = (
    link: IPivotItemProps,
    _defaultRenderer: (link: IPivotItemProps) => JSX.Element
  ): JSX.Element => {
    return (
      <span style={{ fontFamily: "Lato", fontSize: 14 }}>
        {link.headerText}
      </span>
    );
  };
  onPivotLinkClick = (
    _item?: PivotItem,
    _ev?: React.MouseEvent<HTMLElement>
  ) => {
    if (_item.props.linkText === "Recently Used") {
      let { recentMatters } = this.state;
      recentMatters.forEach(matter => {
        matter.checked = false;
      });
      this.setState({
        matterSearchText: "",
        recentMatters: recentMatters,
        selectedPivotKey: "RecentlyUsed"
      });
      this.props.onRecentMatterChanged(null);
    } else if (_item.props.linkText === "Search for Matter") {
      this.setState({
        matterSearchText: "",
        isCalloutVisible: false,
        selectedPivotKey: "Search"
      });
      this.props.onMatterChanged(null);
    }
  };
}
export default MatterSearch;
